import React from "react";
import { connect } from "react-redux";
import "rc-slider/assets/index.css";
import {
    Row,
    Col,
    Label,
} from "reactstrap";
import { formActions } from "../../../../../store/actions/cms/form/form.action";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import { deepClone } from "../../../../../helpers/objectHelper";
import EditorSlider from "../../../../components/editor/tools/EditorSlider";
import ColorPickerFacade from "../../../../../components/UI/Buttons/ColorPickerFacade";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import Select from 'react-select'
import { sourceTypes } from "../../../../../constants/cms/sourceType";
import { templateHelper } from "../../../../areas/template/helpers/templateHelper";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { pageActions } from "../../../../../store/actions/cms/page/page.action";

const borderStyles = [
    { value: 'none', label: 'Ingen' },
    { value: 'dotted', label: 'Dotted' },
    { value: 'dashed', label: 'Dashed' },
    { value: 'solid', label: 'Solid' },
    { value: 'inset', label: 'Inset' },
    { value: 'outset', label: 'Outset' },
    { value: 'double', label: 'Double' },
    { value: 'groove', label: 'Groove' },
    { value: 'ridge', label: 'Ridge' },
]

const optionStyle = {
    singleValue: (styles, { data }) => {
        return {
            ...styles,
            fontSize: '12px',
            width: 120
        };
    }
};
class DividerSettings extends React.Component {
    handleSoftUpdate = (element) => {
        const { dispatch, enviroment, page } = this.props;
        console.log("settings", this.props)
        if (enviroment === sourceTypes.FORM)
            dispatch(formActions.updateFormElement(element));
        if (enviroment === sourceTypes.PAGE)
            dispatch(pageActions.updatePageElement(element, null, page));
        if (enviroment === sourceTypes.TEMPLATE) {
            const template = deepClone(this.props.template);
            const newTemplate = templateHelper.handleElementUpdates(
                element,
                template
            );
            dispatch(templateActions.softUpdate(newTemplate));
        }
    };
    parseColorToRgba(color) {
        const { r, g, b, a } = color.rgb;
        return `rgba(${r},${g},${b},${a})`;
    }
    handleChange = (color, val, path) => {
        const names = path.split(".");
        const element = deepClone(this.props.selectedElement);
        let value = color ? this.parseColorToRgba(color) : val;
        if (names.length === 2) {
            element[names[0]][names[1]] = value;
        }
        if (names.length === 3) {
            element[names[0]][names[1]][names[2]] = value;
        }
        this.handleSoftUpdate(element);
    }

    render() {
        const { selectedElement } = this.props;
        if (selectedElement === undefined) return null;
        return (
            <React.Fragment>
                <ListExpansion footer={false} icon="fa fa-image" defaultExpanded={true} description="DividerSettings">
                    <Row>
                        <Col className="list-setting-item-title">
                            <Label>
                                <SystemLabel name="LineColor" />
                            </Label>
                        </Col>
                        <Col className="list-setting-item-input">
                            <ColorPickerFacade
                                color={selectedElement.data.borderColor}
                                onChange={(color, e) =>
                                    this.handleChange(color, e, "data.borderColor")
                                }
                                path="data.borderColor"
                            />
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col className="list-setting-item-title">
                            <Label>
                                <SystemLabel name="BorderStyle" />
                            </Label>
                        </Col>
                        <Col className="list-setting-item-input">
                            <Select
                                classNamePrefix="jirango-select"
                                className="jirango-select"
                                options={borderStyles.map(t => {
                                    return { value: t.value, label: t.label };
                                })}
                                value={borderStyles.find(t => {
                                    return t.value === selectedElement.data.borderStyle;
                                })}
                                style={{ optionStyle }}
                                onChange={selectedOption =>
                                    this.handleChange(
                                        null,
                                        selectedOption.value,
                                        "data.borderStyle"
                                    )
                                }
                            />
                        </Col>
                    </Row>

                    <hr />
                    <EditorSlider
                        value={parseFloat(selectedElement.data.height)}
                        defaultValue={1}
                        unitChange={() => null}
                        onChange={this.handleChange}
                        units={["px"]}
                        activeUnit={'px'}
                        steps={1}
                        min={1}
                        max={500}
                        path={'data.height'}
                        label="Height"
                    />
                    <hr />
                    <EditorSlider
                        value={parseFloat(selectedElement.data.width)}
                        defaultValue={1}
                        unitChange={() => null}
                        onChange={this.handleChange}
                        units={["%"]}
                        activeUnit={'%'}
                        steps={1}
                        min={1}
                        max={100}
                        path={'data.width'}
                        label="Width"
                    />
                    <hr />
                    <EditorSlider
                        value={parseFloat(selectedElement.data.borderWidth)}
                        defaultValue={1}
                        unitChange={() => null}
                        onChange={this.handleChange}
                        units={["px"]}
                        activeUnit={'px'}
                        steps={0.5}
                        min={0.5}
                        max={50}
                        path={'data.borderWidth'}
                        label="BorderWidth"
                    />

                </ListExpansion>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    const { enviroment } = state.cms;
    let selectedElement = null;
    if (enviroment === sourceTypes.FORM)
        selectedElement = state.form.selectedElement;
    if (enviroment === sourceTypes.PAGE)
        selectedElement = state.page.selectedElement;
    if (enviroment === sourceTypes.TEMPLATE)
        selectedElement = state.template.selectedElement;
    return {
        form: state.form,
        page:state.page,
        selectedElement,
        template: state.template.template,
        enviroment
    };
}

export default connect(mapStateToProps)(DividerSettings);
